/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Queueid1Inputs */

const en_entity_queueid1 = /** @type {(inputs: Entity_Queueid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queue ID`)
};

const de_entity_queueid1 = /** @type {(inputs: Entity_Queueid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

/**
* | output |
* | --- |
* | "Queue ID" |
*
* @param {Entity_Queueid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_queueid1 = /** @type {((inputs?: Entity_Queueid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Queueid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_queueid1(inputs)
	return de_entity_queueid1(inputs)
});
export { entity_queueid1 as "entity_queueId" }